import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  d: "M12 2l-5.5 9h11z"
}), React.createElement("circle", {
  cx: "17.5",
  cy: "17.5",
  r: "4.5"
}), React.createElement("path", {
  d: "M3 13.5h8v8H3z"
})), 'CategorySharp');